import type { MouseEvent } from 'react'

import { forceUpdateService } from './forceUpdate.service'

// GNB 탭 컨테이너의 클릭 이벤트 위임 핸들러 — 클릭된 링크의 도착지로 강제 업데이트를 판정한다.
// 릴리스가 불일치하면 도착지로 full 네비게이션(최신 번들 수신)한다. GNB 목적지는 전부 safe
// 화면(목록·조회)이라 이 시점의 새로고침은 항상 안전하고, 위험 화면(풀이·채점)은 GNB 목적지가
// 아니라 각 화면 내부 버튼으로만 진입해 트리거되지 않는다.
export const checkOnGnbNavigate = (e: MouseEvent<HTMLElement>) => {
  const anchor = (e.target as HTMLElement).closest('a')
  const destinationUrl = anchor?.getAttribute('href')
  if (!destinationUrl) return
  void forceUpdateService.checkNow(destinationUrl)
}
